export default __webpack_public_path__ + "static/media/logged_user_default_logo.50335611.svg";